//import axios from 'axios'

const state = {
  preUniversitari: {
    titolo_studio: null,
    istituto: null,
    annoConseguimento:null,
    votazione: null
  },
  filosofia: {
    titolo_studio: null,
    istituto: null,
    annoConseguimento:null,
    votazione: null
  },
  teologia: {
    titolo_studio: null,
    istituto: null,
    annoConseguimento:null,
    votazione: null
  },
  altro: {
    titolo_studio: null,
    istituto: null,
    annoConseguimento:null,
    votazione: null
  },
  lingueAntiche: {
    latina: null,
    greca: null,
    ebraica:null
  },
  lingueModerne:
  {
    francese: null,
    inglese: null,
    italiana: null,
    spagnola: null,
    tedesca: null
  }

};
const getters = {};
const actions = {
 
};
const mutations = {
  
};

export default {
  state,
  mutations,
  getters,
  actions,
};
